import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbAccordionModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { ErrorModalComponent } from './error-modal/error-modal.component';

@NgModule({
  declarations: [ErrorModalComponent],
  imports: [CommonModule, NgbModalModule, NgbAccordionModule],
})
export class GlobalErrorHandlerModule {}
